<div class="checkout-summary-container">
  <div *ngIf="basket$ | async as basket" class="content">
    <div class="head">
      <div class="headline">
        {{ 'checkout.steps.summary.headline' | translate }}
      </div>
    </div>
    <div class="overview">
      <div class="info-container">
        <div class="grid">
          <div *ngIf="basket.paymentAddress as address" class="invoice-address info">
            <div class="headline">{{ 'checkout.steps.summary.review.invoiceAddress' | translate }}</div>
            <p>{{ address.title }} {{ address.firstName }} {{ address.lastName }}</p>
            <p>{{ address.email }}</p>
            <p><span>{{ address.companyName }}</span><span>{{ address.vatId }}</span></p>
            <p>{{ address.customerId }}</p>
            <p>
              <span>{{ address.line1 }}</span>
              <span>{{ address.line2 }}</span>
              <span>{{ address.postalCode }}</span>
              <span>{{ address.town }}</span>
              <span>{{ address.country?.name }}</span>
            </p>
            <p>{{ address.phone }}</p>
            <p>{{ address.cellphone }}</p>
            <kion-label-button [link]="addressLink"
                               [title]="'checkout.steps.summary.button.edit' | translate"></kion-label-button>
          </div>
          <div *ngIf="basket.deliveryAddress as address" class="delivery-address info">
            <div class="headline">{{ 'checkout.steps.summary.review.deliveryAddress' | translate }}</div>
            <ng-container *ngIf="address.id !== basket?.paymentAddress?.id; else sameAddress">
              <p>{{ address.title }} {{ address.firstName }} {{ address.lastName }}</p>
              <p>{{ address.email }}</p>
              <p><span>{{ address.companyName }}</span><span>{{ address.vatId }}</span></p>
              <p>{{ address.customerId }}</p>
              <p>
                <span>{{ address.line1 }}</span>
                <span>{{ address.line2 }}</span>
                <span>{{ address.postalCode }}</span>
                <span>{{ address.town }}</span>
                <span>{{ address.country?.name }}</span>
              </p>
              <p>{{ address.phone }}</p>
              <p>{{ address.cellphone }}</p>
            </ng-container>
            <ng-template #sameAddress>
              <p> {{ 'checkout.steps.address.deliveryAddress.labels.likeInvoice' | translate }} </p>
            </ng-template>
            <kion-label-button [link]="addressLink"
                               [title]="'checkout.steps.summary.button.edit' | translate"></kion-label-button>
          </div>
          <div *ngIf="basket.paymentMode as payment" class="payment info">
            <div class="headline">{{ 'checkout.steps.summary.review.payment' | translate }}</div>
            <p> {{ payment.name }} {{ basket.paymentInfo?.cardType?.name }} </p>
            <p *ngIf="basket.paymentInfo as info"> {{ info.cardNumber }} </p>
            <kion-label-button *ngIf="!basket.purchaseOrderNumber"
                               [link]="paymentLink"
                               [title]="'checkout.steps.summary.button.edit' | translate"></kion-label-button>
          </div>
          <div *ngIf="basket.deliveryMode as delivery" class="delivery-method info">
            <div class="headline">{{ 'checkout.steps.summary.review.deliveryMethod' | translate }}</div>
            <p> {{ delivery.name }} </p>
            <p> {{ basket.deliveryNotice }} </p>
            <kion-label-button [link]="deliveryLink"
                               [title]="'checkout.steps.summary.button.edit' | translate"></kion-label-button>
          </div>
          <div *ngIf="basket.purchaseOrderNumber as orderNumber" class="poNumber info">
            <div class="headline">{{ 'checkout.steps.summary.review.poNumber' | translate }}</div>
            <p> {{ orderNumber }} </p>
            <kion-label-button [link]="paymentLink"
                               [title]="'checkout.steps.summary.button.edit' | translate"></kion-label-button>
          </div>
        </div>
      </div>
    </div>
    <div class="products">
      <div class="list">
        <kion-basket-list
          [editable]="false"
          [entries]="basket.entries"
          [isMultiVendor]="isMultiVendor$ | async"
          [networkPartner]="basket.entries && basket.entries[0].fulfillmentBy"
        ></kion-basket-list>
      </div>
      <div class="sum">
        <div class="spacer"></div>
        <kion-basket-summary [price]="pricing$ | async"></kion-basket-summary>
      </div>
    </div>
    <div class="additional">
      <div class="optional">
        <div class="additional-info">
          <p class="headline"> {{ 'checkout.steps.summary.additionalInfo.headline' | translate }} </p>
          <div [formGroup]="form" class="textBox">
            <label for="additional-info"></label>
            <textarea [placeholder]="'checkout.steps.summary.additionalInfo.placeHolder' | translate"
                      formControlName="additionalInfo"
                      id="additional-info"></textarea>
          </div>
          <p class="description">{{ 'checkout.steps.summary.additionalInfo.description' | translate }}</p>
        </div>
      </div>
      <div class="mandatory">
        <div *ngIf="!(baseSite$ | async).multiVendor; else multiVendor" class="checkboxes">
          <kion-checkbox (requiredSelected)="requiredSelected($event)" [boxes]="checkboxes$ | async"></kion-checkbox>
        </div>
        <ng-template #multiVendor>
          <div class="checkboxes">
            <kion-checkbox (requiredSelected)="requiredSelected($event)" *ngIf="(checkboxes$ | async)?.length > 0"
                           [boxes]="checkboxes$ | async"></kion-checkbox>
            <kion-checkbox (requiredSelected)="multiVendorRequiredSelected($event)" *ngIf="multiVendorCheckboxes$ | async"
                           [boxes]="multiVendorCheckboxes$ | async"></kion-checkbox>
          </div>
          <span
            [innerHTML]="'checkout.steps.summary.checkbox.description' | translate : { dataPrivacyLink: dataPrivacyLink, contractPartnerDataPrivacyLink: contractPartnerDataPrivacyLink}"></span>
        </ng-template>
      </div>
    </div>
    <div class="navigator">
      <div class="back">
        <kion-label-button [link]="backLink" [title]="'checkout.navigator.back' | translate">
          <svg height="20" img-link viewBox="0 0 16 16" width="20" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.286 4.571L2.522 4.571 6.118 0.975 5.31 0.167 0.335 5.143 5.31 10.118 6.118 9.31 2.522 5.714 14.286 5.714z"
              fill="#9B9B9E"
              fill-rule="evenodd"
              transform="translate(.571 2.857)"></path>
          </svg>
        </kion-label-button>
      </div>
      <div class="forward">
        <kion-button (clicked)="placeOrder()" [disabled]="!canProceed"
                     [title]="'checkout.steps.summary.button.pay' | translate"
                     mode="primary"></kion-button>
      </div>
    </div>
  </div>
</div>
